module.exports = __webpack_public_path__ + "static/media/line-size-3.d8213f87.svg";